/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { AdminConsole } from "./AdminConsole";
import { store } from "./data/store";
// Note that this must be loaded before App
import "./init-dayjs";
// import ReactDOM from 'react-dom/client'
// import { Logger } from 'cms/utils/log/logger'
// import reportWebVitals from './reportWebVitals'
import "data/lang/i18n";

import "styles/app-styles";

ReactDOM.render(
    <StrictMode>
        <AdminConsole />
    </StrictMode>,
    document.getElementById("root"),
);

// TODO: Pending Change - Moving to React 18
//       React DND is preventing this
// const rootElement = document.getElementById('root')
// const isProduction = !process.env.NODE_ENV || process.env.NODE_ENV !== 'development'
// Logger.debug(`ENVIRONMENT: ${process.env.NODE_ENV}`)
// if (isProduction) {
//     // production
//     Logger.debug(`Production build for hydration.`)
//     if (rootElement.hasChildNodes()) {
//         ReactDOM.hydrateRoot(rootElement, <AdminConsole />)
//     } else {
//         const root = ReactDOM.createRoot(rootElement)
//         root.render(<AdminConsole />)
//     }
// } else {
//     // dev uses strict mode (possible double renders)
//     Logger.debug(`Development mode.`)
//     if (rootElement.hasChildNodes()) {
//         ReactDOM.hydrateRoot(rootElement, <StrictMode><AdminConsole /></StrictMode>)
//     } else {
//         const root = ReactDOM.createRoot(rootElement)
//         root.render(<StrictMode><AdminConsole /></StrictMode>)
//     }
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(Logger.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
